<template>
  <div class="user-operation">
    <div class="user-container">
      <div class="user-body">
        <Rectangle
          name="基本信息"
          :path="require('@/assets/img/common/rectangle.png')"
        />
        <el-form
          class="form"
          :model="formData"
          :rules="rules"
          ref="dialogForm"
          label-width="150px"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="登录名" prop="loginName">
                <el-input
                  v-model="formData.loginName"
                  :disabled="type !== 'edit' && type !== 'add'"
                  maxlength="10"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="姓名" prop="userName">
                <el-input
                  v-model="formData.userName"
                  :disabled="type !== 'edit' && type !== 'add'"
                  maxlength="10"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="性别" prop="gender">
                <el-radio-group
                  class="dilink-radio-group"
                  v-model="formData.gender"
                  :disabled="type !== 'edit' && type !== 'add'"
                >
                  <el-radio label="male">男</el-radio>
                  <el-radio label="female">女</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="移动电话" prop="phoneNo">
                <el-input
                  v-model="formData.phoneNo"
                  :disabled="type !== 'edit' && type !== 'add'"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="电子邮箱" prop="email">
                <el-input
                  v-model="formData.email"
                  :disabled="type !== 'edit' && type !== 'add'"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="是否保理用户" prop="isBlUser">
                <el-checkbox
                  v-model="formData.isBlUser"
                  :disabled="type !== 'edit' && type !== 'add'"
                  :true-label="1"
                  :false-label="0"
                >
                </el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="display-flex justify-center text-center mt20">
          <icon-btn
            class="permission-btn mr10"
            path=""
            v-if="type === 'add' || type === 'edit'"
            name="保存"
            @btnClick="submitCheck"
          ></icon-btn>
          <icon-btn
            class="permission-btn"
            path=""
            name="返回"
            @btnClick="goBack"
          ></icon-btn>
        </div>
        <div
          class="pos-relative mt20"
        >
          <Rectangle
            name="所属角色"
            :path="require('@/assets/img/common/rectangle.png')"
          />
          <div class="btn-box" v-if="type !== 'view'">
            <icon-btn
              class="permission-btn mr10"
              :path="
                require('@/assets/img/supplier/mainPage-standReceived/ic_add.png')
              "
              name="分配所属角色"
              @btnClick="handleOperation('add')"
            ></icon-btn>
          </div>
          <Table
            class="mt10"
            :propsArray="propsArray"
            :tableData="tableData"
            :isSection="false"
            alignType="center"
            :ishandle="type === 'edit'"
            :operateArray="['edit']"
            :width="160"
          >
            <template
              slot-scope="prop"
              :slot="item.code"
              v-for="item in propsArray"
            >
              <div :key="item.code">
                <span v-if="prop.column.property === 'defaultRole'">
                  {{ prop.row[prop.column.property] === true ? '是' : '否' }}
                </span>
                <span v-else-if="prop.column.property === 'enabled'">
                  {{
                    prop.row[prop.column.property] === true ? '生效' : '失效'
                  }}
                </span>
                <span v-else>{{ prop.row[prop.column.property] }}</span>
              </div>
            </template>
            <template slot="edit" slot-scope="scope" v-if="type === 'edit'">
              <span class="mr10 link-text" @click="handleDel(scope.row)"
                >移除</span
              >
              <span
                class="link-text"
                @click="handleOperation('edit', scope.row)"
                >修改关联状态</span
              >
            </template>
          </Table>
        </div>
      </div>
    </div>
    <role-dialog ref="roleDialog" @success="queryDetails"></role-dialog>
  </div>
</template>
<script>
import {
  opUserDetails,
  opUserMaintainInfo,
  opUserModify,
  opUserAdd,
  opUserRoleDelete,
} from '@/http/usercenter.js';
import Rectangle from '@/components/public/Element/rectangle.vue';
import RoleDialog from './RoleDialog.vue';
import { iphone_regfun } from '@/utif/formValidator'
export default {
  components: {
    Rectangle,
    RoleDialog,
  },
  data() {
    return {
      userNo: this.$route.query.userNo,
      type: this.$route.name.split('-')[this.$route.name.split('-').length - 1],
      isSaveInfo: false, // 新增模式下是否首先保存了基本信息
      rules: {
        loginName: [{ required: true, trigger: 'blur', message: '请填写' }],
        userName: [{ required: true, trigger: 'blur', message: '请填写' }],
        phoneNo: [
          { required: true, message: '请填写', trigger: 'blur' },
          { validator: iphone_regfun, trigger: 'blur' }
        ],
        gender: [{ required: true, trigger: 'blur', message: '请选择' }],
        telephone: [],
      },
      formData: {
        loginName: '',
        userName: '',
        phoneNo: '',
        gender: '',
        telephone: '',
        opRoles: [
          // {
          //   roleNo: "11",
          //   roleCode: "PR002",
          //   roleName: "平台运营-风控",
          //   defaultRole: true,
          //   enabled: true,
          // },
        ],
      },
      propsArray: [
        {
          code: 'roleName',
          label: '角色名称',
          minWidth: 200,
        },
        {
          code: 'enabled',
          label: '角色用户关联状态',
          minWidth: 160,
        },
        {
          code: 'defaultRole',
          label: '是否默认角色',
          minWidth: 160,
        },
      ],
      tableData: [],
    };
  },
  mounted() {
    // this.userNo ? this.queryDetails() : "";
    if (this.userNo) {
      this.opUserMaintainInfo();
      this.queryDetails();
    }
  },
  methods: {
    handleOperation(type, row) {
      if( this.type === 'add' && !this.isSaveInfo) {
        this.$message({
          message: "请先保存基本信息",
          type: 'warning',
        });
        return
      }
      this.$refs.roleDialog.type = type;
      if (row) {
        this.$refs.roleDialog.formData = { ...row };
      }
      this.$refs.roleDialog.getRoleList();
      this.$refs.roleDialog.dialogShow = true;
      this.$refs.roleDialog.userNo = this.userNo;
    },
    submitCheck() {
      this.$refs.dialogForm.validate((result) => {
        if (result) {
          let handleFun = opUserAdd;
          const data = {
            ...this.formData,
            userNo: this.userNo ? this.userNo : null,
          };
          if (this.type === 'edit') {
            handleFun = opUserModify;
          }
          handleFun(data)
            .then((res) => {
              
              if (res.ret === 0) {
                this.$message({
                  message: res.msg,
                  type: 'success',
                });
                this.isSaveInfo = true
                this.userNo = res.data.userNo
                // this.goBack();
              }
            })
        }
      });
    },
    handleDel(row) {
      this.$DLMessageBox({
        type: 'warn',
        title: '温馨提示',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        content: '确认移除吗？',
        callback: (action) => {
          if (action == 'confirm') {
            opUserRoleDelete(row).then((res) => {
              if (res.ret === 0) {
                this.$message({
                  message: res.msg,
                  type: 'success',
                });
                this.queryDetails();
              }
            })
          }
        },
      });
    },
    queryDetails() {
      opUserDetails({ userNo: this.userNo })
        .then((res) => {
          if (res.ret === 0) {
            this.formData = { ...res.data };
            if (res.data.opRoles) {
              this.tableData = [...res.data.opRoles];
            }
          }
        })
    },
    opUserMaintainInfo() {
      opUserMaintainInfo({ userNo: this.userNo })
        .then((res) => {
          if (res.ret === 0) {
            // this.formData = { ...res.data };
          }
        })
    },
    goBack() {
      this.formData = {
        loginName: '',
        userName: '',
        phoneNo: '',
        gender: '',
        telephone: '',
        opRoles: [],
      };
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="less" scoped>
.user-operation {
  .user-container {
    width: 80%;
    margin: 20px auto;
    .user-body {
      .el-form-item {
        min-height: 41px;
      }
    }
    .btn-box {
      position: absolute;
      top: -15px;
      right: 0;
    }
  }
}
</style>
